import "./person-services.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Button from "../../atoms/button/button";
import React from "react";
import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import ServiceCard from "../../atoms/service-card/service-card";
import ServiceCarousel from "../service-carousel/service-carousel";
import { Tooltip } from "antd";
import { navigate } from "gatsby";

const PersonServicesSection = (props: ReferenciaContenido) => {
  const personServiceData = props;

  return (
    <div className="m-person-services">
      <div className="m-person-services__title-container">
        <div className="m-person-services__title-container__text">
          <h2>{personServiceData?.tituloGeneral}</h2>
        </div>
      </div>
      <div className="center">
        <div className="m-person-services__cards hide-on-mobile">
          {personServiceData &&
            personServiceData.referenciaPlantillaContenido &&
            personServiceData.referenciaPlantillaContenido.map(
              (cardInfo, idx) => {
                if (cardInfo) {
                  return idx == 0 ? (
                    <Tooltip
                      placement="top"
                      title={cardInfo?.tituloBoton || ""}
                    >
                      <div>
                        <ServiceCard
                          key={cardInfo?.tituloBanner}
                          text={cardInfo?.tituloBanner}
                          icon={cardInfo?.imagenPrincipal[0]?.file?.url}
                          alt={cardInfo?.imagenPrincipal[0]?.title}
                          href={cardInfo?.redireccionBoton}
                        />
                      </div>
                    </Tooltip>
                  ) : idx == 1 ? (
                    <Tooltip
                      placement="top"
                      title={cardInfo?.tituloBoton || ""}
                    >
                      <div>
                        <ServiceCard
                          key={cardInfo?.tituloBanner}
                          text={cardInfo?.tituloBanner}
                          icon={cardInfo?.imagenPrincipal[0]?.file?.url}
                          alt={cardInfo?.imagenPrincipal[0]?.title}
                          href={cardInfo?.redireccionBoton}
                        />
                      </div>
                    </Tooltip>
                  ) : (
                    <ServiceCard
                      key={cardInfo?.tituloBanner}
                      text={cardInfo?.tituloBanner}
                      icon={cardInfo?.imagenPrincipal[0]?.file?.url}
                      alt={cardInfo?.imagenPrincipal[0]?.title}
                      href={cardInfo?.redireccionBoton}
                    />
                  );
                }
              }
            )}
        </div>
      </div>

      <div className="m-person-services__cards-mobile">
        <ServiceCarousel
          cardsArray={personServiceData?.referenciaPlantillaContenido}
        />
      </div>

      <div className="button-container">
        <Button
          text={personServiceData?.tituloBoton}
          classname={"secondary know-more-btn l-large"}
          type="button"
          isDisabled={false}
          strictCss={false}
          onClickAction={() => {
            navigate("/servicios");
          }}
          gtmMark={"gtmRedDeAmorServiciosRedAmorConocerMas"}
        />
      </div>
    </div>
  );
};

export default PersonServicesSection;
